/**
 * @Description 全屏
 */

import { FC, RefObject, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';

const FullScreen: FC<{ containerRef: RefObject<HTMLDivElement>, isSpot?: boolean }> = ({
  containerRef,
  isSpot = false
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handler);
    return () => document.removeEventListener('fullscreenchange', handler);
  }, []);

  const methods = useMethods({
    toggle() {
      const el = containerRef.current;
      if (!el) return;
      if (!document.fullscreenElement) {
        el.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
  });

  return (
    <div className={cs(
      styles.fullScreenCon,
      isSpot ? styles.isSpot : '',
      isFullscreen ? styles.isFull : ''
    )} onClick={methods.toggle}>
      {
        isFullscreen ? <span className='pr-6'>
        退出全屏
        </span> : <></>
      }
      <IconFont iconHref={isFullscreen ? 'iconic_shouqi1' : 'iconic_quanping'} />
    </div>
  );
};

export default FullScreen;
